import { apiGet } from "../ApiMethod";
import { setDroneNest } from "../../mappers";

export const getDroneNestById = async (id, cancelToken = null) => {
  const response = await apiGet("_dronenest", {}, id, cancelToken);
  return { ...response, data: setDroneNest(response.data) };
};
